import React from 'react';
import '../styles/pages/TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-conditions-page" style={{ backgroundImage: 'url("/images/BG.png")' }}>
      {/* Logo in top left corner for desktop, center for mobile */}
      <div className="logo-container">
        <a href="/" title="Go to Home Page">
          <img src="/images/LOGO.png?v=20241118" alt="L&T Finance Logo" className="header-logo" />
        </a>
      </div>
      
      {/* Main content container */}
      <div className="terms-content">
        <div className="terms-container">          <h1 className="terms-title">Terms & Conditions</h1>
          <div className="terms-text">
            <p className="intro-text">
              I, the Participant hereby agree to these terms and conditions to participate in the 'LTF Game Changer Poster with Jasprit Bumrah', Campaign, promoted, organized and managed by L&T Finance Limited (formerly known as L&T Finance Holdings Limited) ("LTF") is a company established under Indian laws with its Registered Office at Brindavan, Plot No. 177, C.S.T Road, Kalina, Santacruz (East), Mumbai, Maharashtra, India, 400098.
            </p>

            <div className="terms-section">
              <h2>1. Eligibility</h2>
              <p>Only verified customers of LTF Business Loans are eligible to participate. Participants must verify their mobile number via OTP to generate a valid poster. Posters must include the name of the participant's business as registered with LTF.</p>
            </div>

            <div className="terms-section">
              <h2>2. Campaign Description</h2>
              <p>Participants can generate an AI-powered personalized digital poster featuring Jasprit Bumrah through a dedicated microsite. The AI tool will assist in creating taglines and backgrounds for the posters. Selected posters may be displayed on digital billboards as part of the campaign's promotional efforts.</p>
            </div>

            <div className="terms-section">
              <h2>3. Consent and Permissions</h2>
              <p>By participating, you grant LTF the right to use your name, business name, and poster content for marketing, publicity, and promotional purposes without further compensation. You consent to the collection and use of your personal data (such as mobile number and business details) for the purposes of this Campaign in accordance with applicable data protection laws. You confirm that all information submitted is accurate and true to the best of your knowledge.</p>
            </div>

            <div className="terms-section">
              <h2>4. Ownership and Intellectual Property Rights</h2>
              <p>All content generated via the microsite, including AI-assisted posters, is the property of LTF. Participants acknowledge that their use of Jasprit Bumrah's image is limited solely to the scope of this campaign and within the tools provided by LTF. Participants may not reuse or reproduce the posters for commercial purposes beyond the Campaign without express written permission from LTF. LTF retains all rights to modify, use, display, reproduce, or remove any poster submitted or generated via the platform.</p>
            </div>

            <div className="terms-section">
              <h2>5. Digital Billboard Display</h2>
              <p>LTF will select posters for display on digital billboards at its sole discretion. Submission of a poster does not guarantee its selection for billboard display. Selected posters may be modified for design and quality standards before display.</p>
            </div>

            <div className="terms-section">
              <h2>6. Restrictions</h2>
              <p>Posters may only be created using the verified mobile number of an LTF customer. Use of inappropriate, offensive, or misleading content will lead to immediate disqualification. Participants must not include third-party trademarks, copyrighted materials, or any content that infringes upon others' rights.</p>
            </div>

            <div className="terms-section">
              <h2>7. Limitation of Liability</h2>
              <ul>
                <li>LTF expressly disclaims all warranties of any kind, whether express or implied.</li>
                <li>LTF is not responsible for any technical failures or malfunctions of any kind, including but not limited to computer or mobile hardware or software issues, data loss, or any other errors that may affect the submission, generation, or transmission of entries.</li>
                <li>LTF shall not be liable for any damages, losses, or injuries sustained as a result of participating in the Campaign, the use or misuse of the AI-generated images, or acceptance of any prizes.</li>
                <li>In no event shall LTF be liable under these terms for any loss to the participant for any error or omission or any consequential, special, indirect, exemplary, punitive, or any loss of profit, goodwill or opportunity or other damages, including, arising out of any failure or alleged failure to perform any of its obligations under these terms whether based in contract, tort (including negligence) or otherwise.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>8. Changes and Termination</h2>
              <p>LTF reserves the right to modify, suspend, or terminate the Campaign or these Terms at any time without prior notice.</p>
            </div>

            <div className="terms-section">
              <h2>9. Dispute Resolution</h2>
              <p>Any disputes arising out of this Campaign shall be subject to the exclusive jurisdiction of the courts in Mumbai, India.</p>
            </div>

            <div className="terms-section">
              <h2>10. Contact</h2>
              <p>For queries regarding the campaign, please visit <a href="https://ltfinance.com" target="_blank" rel="noopener noreferrer">LTFinance.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
